import React from 'react';
import './Home.css';

// Import required components and constants
import { Button } from '../../../components';
import { home } from '../../../constants';

import { FaBrain } from 'react-icons/fa';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const Home = () => {

  const { image, subtitle, title, content, buttonText, buttonLink } = home;


  return (
    <section className='home'>

      {/* Background image for each slide */}
      <img src={image} alt="Home-Pic" />

      {/* Content overlay */}
      <div className="content">
        <div className="text">
          <h5>{subtitle}</h5> {/* Subtitle with Icon */}
          <h3>{title}</h3> {/* Main title */}
          <p>{content}</p> {/* Home Description */}
          <Button link={buttonLink} title={buttonText} /> {/* CTA Button */}
        </div>
      </div>

    </section>
  )
}

export default Home;